const Divider = () => {
    return (
        <div className="flex items-center gap-4">
            <div className="flex-1 h-px bg-[#CFCFCF]" />
            <span className="text-[20px] font-medium text-black">or</span>
            <div className="flex-1 h-px bg-[#CFCFCF]" />
        </div>
    );
};

export default Divider;